// extracted by mini-css-extract-plugin
module.exports = {"appStyle":"_1emJwQLW1amxHi8Ni5Ytl6"};